module.exports = __webpack_public_path__ + "img/guandai_xc6.23381887.jpg";